import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../Enums/MagicField.enum';

const specializationScheme: ItemScheme[] = [
	{
		type: MagicField.RICH_TEXT_FIELD,
		key: 'specialization',
		settings: {
			required: true,
		},
	},
];

const educationAndProfileOfTheTherapistScheme: ItemScheme[] = [
	{
		type: MagicField.RICH_TEXT_FIELD,
		key: 'educationAndProfileOfTheTherapist',
		settings: {
			required: true,
		},
	},
];

const aboutTherapyScheme: ItemScheme[] = [
	{
		type: MagicField.RICH_TEXT_FIELD,
		key: 'aboutTherapy',
		settings: {
			required: true,
		},
	},
];

const certificatesAndDiplomasScheme: ItemScheme[] = [
	{
		type: MagicField.RICH_TEXT_FIELD,
		key: 'certificatesAndDiplomas',
		settings: {
			required: true,
		},
	},
];

const therapistPriceRangeScheme: ItemScheme[] = [
	{
		type: MagicField.TEXT,
		title: 'component.therapistDetail.therapistPriceRange',
		subType: 'header',
	},
	{
		type: MagicField.CONTAINER,
		key: 'therapistPriceRange',
		children: [
			{
				type: MagicField.TEXT_FIELD,
				key: 'from',
				title: 'component.userFirstLoginTherapistComponent.priceRangeFrom',
				settings: {
					required: true,
					errorMessage: 'validation.therapistPriceRangeForm.priceRangeFrom',
				},
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'to',
				title: 'component.userFirstLoginTherapistComponent.priceRangeTo',
				settings: {
					required: true,
					errorMessage: 'validation.therapistPriceRangeForm.priceRangeTo',
				},
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'lengthOfConsultation',
				title:
					'component.userFirstLoginTherapistComponent.lengthOfConsultation',
				subType: 'number',
				settings: {
					suffix: 'min',
					required: true,
					errorMessage:
						'validation.therapistPriceRangeForm.lengthOfConsulation',
				},
			},
		],
	},
];

const doctorNpwzScheme: ItemScheme[] = [
	{
		type: MagicField.TEXT_FIELD,
		title: 'component.p1DoctorSetup.medicalWorkerNumber',
		key: 'npwz',
		settings: {
			required: true,
		},
	},
];

export const userMetaDataSchemes: Record<string, ItemScheme[]> = {
	specialization: specializationScheme,
	educationAndProfileOfTheTherapist: educationAndProfileOfTheTherapistScheme,
	certificatesAndDiplomas: certificatesAndDiplomasScheme,
	therapistPriceRange: therapistPriceRangeScheme,
	aboutTherapy: aboutTherapyScheme,
	npwz: doctorNpwzScheme,
};
